import { Stack } from "@mui/material";
import { isPageDisabled } from "features/shared/lib/acl";
import React from "react";
import { NavLink } from "react-router-dom";
import { cn } from "utils/styling";

import { theme } from "../../styles/theme";

export const SecondaryNavbar = ({ activeTabs, className, navLinks }) => {
  return (
    <Stack className={`font-ds-headline-xs ${className} !border-b-2  border-b-ds-soft`} spacing={theme.spacing(8)}>
      {navLinks.map((navLink, index) => {
        const isDisabled = isPageDisabled({ activePages: activeTabs, page: navLink });
        return (
          <NavLink
            className={({ isActive }) =>
              cn(
                "mb-[-1.5px] !border-b-2 px-4 py-2 uppercase border-b-ds-soft",
                isActive
                  ? cn("text-lds-foreground-heading-active border-b-ds-accent", "border-b-4 ")
                  : isDisabled
                  ? "cursor-auto !border-b  text-lds-foreground-disabled"
                  : " text-lds-foreground-heading-initial  hover:text-lds-foreground-heading-hover hover:border-b-ds-accent"
              )
            }
            key={index}
            onClick={(e) => handleClick(e, isDisabled)}
            to={navLink.to}
          >
            {navLink.linkName}
          </NavLink>
        );
      })}
    </Stack>
  );
};

const handleClick = (e, isDisabled) => {
  if (isDisabled) e.preventDefault();
};
